export const documentFileTypes = ['.csv', '.doc', '.docx', '.json', '.pdf', '.rtf', '.txt', '.xls', '.xlsx', '.zip'];
export const imageFileTypes = ['.bmp', '.gif', '.jpeg', '.jpg', '.png', '.tif', '.tiff'];
